module.exports = __webpack_public_path__ + "static/cely_rose_grossesse_1-e9c29c066d43aadc91c0b32b2363fad3.jpg";